import {Observable}                  from 'rxjs';
import {distinctUntilChanged, pluck} from 'rxjs/operators';

import PlaybackStatus from '../../State/Stores/Playback/Constants/PlaybackStatus';
import Playback       from '../../State/Stores/Playback/Playback';

const createPlaybackStatusStream = (
    playbackStoreUpdate$: Observable<Playback>
): Observable<PlaybackStatus> =>
    playbackStoreUpdate$
        .pipe(
            pluck<Playback, PlaybackStatus>('playbackStatus'),
            distinctUntilChanged()
        );

export default createPlaybackStatusStream;